import React, { useState } from 'react'
import {
  DialogContentText,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core'
import { Translate } from 'react-localize-redux'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import PlayersAutocomplete from './PlayersAutocomplete'
import SaveUpdateButtons from './SaveUpdateButtons'
import TeamSelection from './TeamSelection'
import {
  CARD_TYPES,
  CARD_REASONS,
  MATCH_HIGHLIGHT_TEAMS,
} from 'constants/match'

const AddEditCard = ({
  onClose,
  handleSave,
  handleUpdate,
  existingData,
  errorMinute,
  minute,
  setErrorMinute,
  participantsList,
  resetCommonFields,
}) => {
  const [scoredTeam, setScoredTeam] = useState(
    existingData && existingData.team
      ? existingData.team
      : MATCH_HIGHLIGHT_TEAMS.own
  )
  const [p1value, setP1Value] = useState(null)
  const [card, setCard] = useState(
    existingData ? existingData.card_type : CARD_TYPES[0].key
  )
  const [reason, setReason] = useState(
    existingData ? existingData.reason : CARD_REASONS[0].key
  )
  const [resetPlayer, setResetPlayer] = useState(false)

  const resetForm = () => {
    resetCommonFields()
    setScoredTeam(MATCH_HIGHLIGHT_TEAMS.own)
    setP1Value(null)
    setCard(CARD_TYPES[0].key)
    setReason(CARD_REASONS[0].key)
    setResetPlayer(true)
  }
  const handleScoredTeam = (val) => {
    if (val === MATCH_HIGHLIGHT_TEAMS.opponent) {
      setP1Value('')
    }
    setScoredTeam(val)
  }
  const save = (exit = false) => {
    if (errorMinute) return false

    if (!minute) {
      setErrorMinute(true)

      return false
    }
    const createData = {
      type: 'card',
      team: scoredTeam,
      card_type: card,
      reason,
      minute,
      player_1: p1value,
    }
    handleSave(createData).then(() => {
      resetForm()
      if (exit === true) {
        onClose()
      }
    })

    return false
  }
  const update = (highLightId) => {
    if (errorMinute) return false

    const updateData = {
      type: 'card',
      team: scoredTeam,
      card_type: card,
      reason,
      minute,
      player_1: p1value,
    }
    handleUpdate(highLightId, updateData)
    onClose()

    return false
  }

  return (
    <>
      <DialogContentText>
        <Translate id="matches.highlights.enter-card-details" />
      </DialogContentText>
      <Grid item style={{ marginTop: '0.25rem' }}>
        <TeamSelection
          selectedTeam={scoredTeam}
          handleTeam={handleScoredTeam}
        />
      </Grid>
      <Grid item>
        <FormControl variant="outlined" margin="dense">
          <InputLabel id="demo-simple-select-label">
            <Translate id="matches.highlights.card-type" />
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="match-type-selected-outlined"
            value={card}
            onChange={(event) => {
              return setCard(event.target.value)
            }}
            label={<Translate id="matches.highlights.card-type" />}
          >
            {CARD_TYPES.map((p) => {
              return (
                <MenuItem key={p.key} value={p.key}>
                  {p.displayValue}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </Grid>
      {scoredTeam !== MATCH_HIGHLIGHT_TEAMS.opponent && (
        <Grid item>
          <PlayersAutocomplete
            setPValue={setP1Value}
            label={<Translate id="matches.highlights.punished-player" />}
            savedPlayer={
              existingData && existingData.relationships?.player_1?.uuid
                ? existingData.relationships.player_1.uuid
                : 0
            }
            players={participantsList}
            resetPlayer={resetPlayer}
            setResetPlayer={setResetPlayer}
          />
        </Grid>
      )}
      <Grid item>
        <FormControl variant="outlined" margin="dense">
          <InputLabel id="demo-simple-select-label">
            <Translate id="matches.highlights.reason" />
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="match-type-selected-outlined"
            value={reason}
            onChange={(event) => {
              return setReason(event.target.value)
            }}
            label={<Translate id="matches.highlights.reason" />}
          >
            {CARD_REASONS.map((p) => {
              return (
                <MenuItem key={p.key} value={p.key}>
                  {p.displayValue}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </Grid>

      <SaveUpdateButtons
        save={save}
        existingData={existingData}
        update={update}
      />
    </>
  )
}
AddEditCard.defaultProps = {
  onClose: () => 0,
  existingData: null,
  handleSave: () => 0,
  handleUpdate: () => 0,
}
AddEditCard.propTypes = {
  onClose: PropTypes.func,
  handleSave: PropTypes.func,
  handleUpdate: PropTypes.func,
  participantsList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  existingData: PropTypes.shape(),
  errorMinute: PropTypes.bool.isRequired,
  minute: PropTypes.number.isRequired,
  setErrorMinute: PropTypes.func.isRequired,
  resetCommonFields: PropTypes.func.isRequired,
}
export default connect(
  ({
    matches: {
      current: { id },
    },
  }) => ({
    matchId: id,
  }),
  {}
)(AddEditCard)
